<template>
	<div class="container__crud">
		<div class="container__crudactions">
			<div class="container__crudactions__cruddownload">
				<div class="container__crudactions__cruddownload__crud">
					<Button
						:label="$t('deleteSelected')"
						color="trv-error"
						outlined
						icon="far fa-trash-alt"
						semantic-class="tiny"
						:disabled="isDeleteButtonDisabled"
						width-auto
						@click="toggleExclusionAlert"
					/>
					<Button
						:label="$t('create')"
						color="trv-default"
						semantic-class="tiny"
						width-auto
						@click="showNewModelForm"
					/>
					<ExclusionAlert
						v-if="showExclusionAlert"
						:items-to-delete="modelList.filter((item) => item.isCheckedToDelete)"
						@cancel="toggleExclusionAlert"
						@confirm="deleteModels"
					>
						<template #item="{ item }">
							<li class="exclusion-alert-item">
								{{ $t('name') }} : {{ item.nomePerfilDeAcesso }} - {{ $t('descricao') }} :
								{{ item.descricaoPerfilDeAcesso }}
							</li>
						</template>
					</ExclusionAlert>
				</div>
				<div class="container__crudactions__cruddownload__download">
					<!-- <DownloadButton /> -->
				</div>
			</div>
			<div class="container__crudactions__filtercollums">
				<div class="container__crudactions__filtercollums__filter">
					<InputSearch
						v-model="textFilter"
						style="margin-right: 0.5rem"
						:placeholder="$t('search')"
					/>
				</div>
				<div class="container__crudactions__filtercollums__collumns">
					<DropdownCheckbox v-model="tableHeaders" />
				</div>
			</div>
		</div>
		<CrudTable
			:headers="headersAtivos"
			:data="modelsToBeShowedAndTotal.items"
			:table-configuration="tableConfiguration"
			:show-edit-model-form="showEditModelForm"
			@sortConfig="
				sortBy = $event.sortBy
				sortType = $event.sortType
			"
		>
			<template #outer-action-button="dataObject">
				<KebabMenu
					v-model="intention"
					:options="kebabOptions"
					:properties="dataObject"
				/>
			</template>
		</CrudTable>
		<div class="container__crud__pagination">
			<Pagination
				ref="ref__pagination"
				:quantity-per-page="10"
				:quantity-per-page-options="[10, 20, 30]"
				:total-records="modelsToBeShowedAndTotal.total"
				@setStartEnd="setStartEnd"
				@setQuantityPerPage="setQuantityPerPage"
			/>
		</div>
		<CrudForm
			:is-visible="showForm"
			:change-is-visible="changeFormAndCloseAllActions"
			:title-form="titleForm"
			:backdrop="true"
		>
			<template #form>
				<div>
					<div style="display: flex; flex-direction: column; gap: 0.5rem">
						<InputText
							v-model="model.nomePerfilDeAcesso"
							:label="$t('name')"
						/>
						<InputText
							v-model="model.descricaoPerfilDeAcesso"
							:label="$t('description')"
						/>
						<DropdownCheckboxFk
							v-model="model.acessos"
							:label="$t('access')"
							:ignore-properties="['label', 'value', 'id', 'codigo', 'descricao', 'Nome']"
							:dropdown-options="
								roles.map((r) =>
									Object.assign(r, {
										value: r.id,
										label: r.descricao,
										[$t('code')]: r.codigo,
										[$t('description')]: r.descricao,
										Nome: r.descricao,
									}),
								)
							"
						/>
					</div>

					<div class="container__crud__crudform__buttons">
						<Button
							:label="$t('save')"
							:loading="isLoading"
							color="trv-default"
							semantic-class="mini"
							:disabled="disableSaveButton || !camposObrigatoriosPreenchidos"
							@click="saveClick()"
						/>
						<Button
							:label="$t('cancel')"
							color="trv-default"
							semantic-class="mini"
							outlined
							@click="changeFormAndCloseAllActions"
						/>
					</div>
				</div>
			</template>
		</CrudForm>
	</div>
</template>

<script>
// import { v4 as uuidv4 } from "uuid";

import Button from '../../../components/Button/Button'
import CrudForm from '../../../components/CrudForm/CrudForm'
import CrudTable from '../../../components/CrudTable/CrudTable'
// import DownloadButton from "../../../components/DownloadButton/DownloadButton";
import DropdownCheckbox from '../../../components/DropdownCheckbox/DropdownCheckbox'
// import Dropdown from "../../../components/Dropdown/Dropdown";
import DropdownCheckboxFk from '../../../components/DropdownCheckboxFk/DropdownCheckboxFk.vue'
import ExclusionAlert from '../../../components/ExclusionAlert/ExclusionAlert.vue'
import InputSearch from '../../../components/InputSearch/InputSearch'
import InputText from '../../../components/InputText/InputText'
import KebabMenu from '../../../components/KebabMenu/KebabMenu'
import Pagination from '../../../components/Pagination/Pagination'

import ControllingPaginationMixins from '../../../mixins/ControllingPaginationMixins'
import RegistersMixins from '../../../mixins/RegistersMixins'
import useMagicRegExp from '../../../mixins/useMagicRegExp'

import {
	createPerfilDeAcesso,
	deletePerfilDeAcessoByIdList,
	getPerfisDeAcesso,
	getRoles,
	updatePerfilDeAcesso,
} from '../../../services/requests/PerfilDeAcessoRequests.js'

import _ from 'lodash'

export default {
	components: {
		Button,
		CrudForm,
		CrudTable,
		KebabMenu,
		// DownloadButton,
		DropdownCheckbox,
		DropdownCheckboxFk,
		// Dropdown,
		InputSearch,
		InputText,
		Pagination,
		ExclusionAlert,
	},
	/**
	 * Mixins
	 * - ControllingPaginationMaxins: Mixin para controler a paginacao
	 * - RegistersMixins: Mixin com funções compartilhadas para realizar o CRUD
	 */
	mixins: [ControllingPaginationMixins, RegistersMixins, useMagicRegExp],
	data() {
		return {
			isLoading: false,
			showExclusionAlert: false,
			roles: [],
			perfisDeAcesso: [],
			intention: {},
			headersSelecionados: ['descricaoPerfilDeAcesso', 'nomePerfilDeAcesso'],
			rolesAuxiliar: [],
			/**
			 * Campos que devem ser feito bind para cadastro ou edicao de registro
			 */
			model: {
				descricaoPerfilDeAcesso: '',
				nomePerfilDeAcesso: '',
				acessos: [],
			},
			/**
			 * Configuração da tabela
			 */
			tableConfiguration: {
				statusTable: this.$t('loading') + '...',
				subtitleCardPropertie: 'codigo',
				titleCardPropertie: 'codigo',
			},
			tableHeaders: [
				{ key: 'nomePerfilDeAcesso', value: this.$t('name'), isActive: true },
				{
					key: 'descricaoPerfilDeAcesso',
					value: this.$t('description'),
					isActive: true,
				},
			],
			/**
			 * talhoes que serão dispostas no dropdown para atrelar ao plantio
			 */
			talhoes: [],

			/**
			 * estratos florestal que serão dispostos no dropdown para atrelar ao plantio
			 */
			estratoFlorestais: [],
		}
	},
	computed: {
		acessos() {
			return this.perfisDeAcesso?.map((perfil) => {
				return Object.assign(perfil, {
					[this.$t('name')]: perfil.nomePerfilDeAcesso,
					[this.$t('description')]: perfil.descricaoPerfilDeAcesso,
					id: perfil.perfilDeAcessoId,
				})
			})
		},

		kebabOptions() {
			return [
				{
					value: 'editar',
					label: this.$t('edit'),
				},
			]
		},
		headersAtivos() {
			const ativos = this.tableHeaders.filter((f) => this.headersSelecionados.includes(f.key))

			ativos.forEach((f) => {
				f.isActive = true
			})

			return ativos
		},
		/**
		 * Retorna se os campos obrigatórios estão preenchidos
		 */
		camposObrigatoriosPreenchidos() {
			return (
				this.model.nomePerfilDeAcesso &&
				this.model.descricaoPerfilDeAcesso &&
				this.model.acessos.length
			)
		},
	},
	watch: {
		'model.acessos': {
			handler(v) {
				this.model.roles = this.roles.filter((role) => v.includes(role.id))
			},
			deep: true,
		},
		tableHeaders: {
			deep: true,
			handler(value) {
				this.headersSelecionados = value.filter((f) => f.isActive).map((m) => m.key)
			},
		},
		intention(value) {
			const model = this.modelList.find(
				(model) => model.perfilDeAcessoId === value.properties.perfilDeAcessoId,
			)

			switch (value.intent) {
				case 'editar':
					this.showEditModelForm(model)
					break
			}
		},
	},
	/**
	 * Antes de criar o objeto seta a quantidade de itens por pagina
	 * e a ordenacao da tabela
	 */
	created() {
		this.quantityPerPage = 10
		this.orderTable = ['codigo']

		getPerfisDeAcesso().then((response) => {
			const { result: perfis } = response.data
			// perfis.forEach((usuario) => {
			//   this.formataUsuarioParaTabela(usuario);
			// });
			this.modelList = perfis.map((perfil) =>
				Object.assign(perfil, { id: perfil.perfilDeAcessoId }),
			)
		})

		getRoles().then((response) => {
			this.roles = response.data.result
		})
	},
	methods: {
		toggleExclusionAlert() {
			this.showExclusionAlert = !this.showExclusionAlert
		},

		/**
		 * Cria novo Plantio no banco de dados
		 */
		create() {
			this.isLoading = true
			createPerfilDeAcesso({
				Nome: this.model.nomePerfilDeAcesso,
				Descricao: this.model.descricaoPerfilDeAcesso,
				RolesIds: this.model.acessos,
			})
				.then((response) => {
					const { result: perfilDeAcesso, isError } = response.data
					this.disableSaveButton = false

					if (!isError) {
						this.cleanModel()
						this.isLoading = false
						this.formataFazendaParaTabela(perfilDeAcesso)
						perfilDeAcesso.id = perfilDeAcesso.perfilDeAcessoId
						this.modelList.unshift(perfilDeAcesso)
						this.model = JSON.parse(JSON.stringify(perfilDeAcesso))

						this.showForm = false

						this.mutationShowMessage({
							messageTitle: this.$t('sucesso'),
							messageIcon: 'far fa-check-circle',
							messageType: 'success',
						})
					}
				})
				.catch(() => {
					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageIcon: 'far fa-cross-circle',
						messageType: 'error',
					})
				})
		},

		/**
		 * Formata campos do model para exibir na tabela de crud
		 */
		formataFazendaParaTabela(perfilDeAcesso) {
			perfilDeAcesso.acessos = []
		},

		/**
		 * Atualiza fazenda no banco de dados
		 */
		update() {
			this.isLoading = true
			updatePerfilDeAcesso({
				IdPerfilDeAcesso: this.model.perfilDeAcessoId,
				Nome: this.model.nomePerfilDeAcesso,
				Descricao: this.model.descricaoPerfilDeAcesso,
				RolesAtribuidas: this.model.acessos,
				RolesRevogadas: _.difference(this.rolesAuxiliar, this.model.acessos),
			}).then((response) => {
				const { isError } = response.data
				this.disableSaveButton = false

				if (!isError) {
					this.isLoading = false
					const indexPerfilDeAcesso = this.modelList
						.map((m) => m.perfilDeAcessoId)
						.indexOf(this.model.perfilDeAcessoId)
					this.$set(this.modelList, indexPerfilDeAcesso, JSON.parse(JSON.stringify(this.model)))

					this.showForm = false

					this.mutationShowMessage({
						messageTitle: this.$t('sucesso'),
						messageIcon: 'far fa-check-circle',
						messageType: 'success',
					})
				} else {
					this.isLoading = false
					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageIcon: 'far fa-check-circle',
						messageType: 'error',
					})
				}
			})
		},

		/**
		 * Exclui fazenda no banco de dados
		 */
		deleteModels(email) {
			var emailUsuario = localStorage.getItem('email')
			if (email === emailUsuario) {
				const confirmResult = confirm('Deseja realmente excluir esses registros?')
				if (confirmResult) {
					deletePerfilDeAcessoByIdList(this.modelsIdWithCheckedToDelete).then(() => {
						this.modelsIdWithCheckedToDelete.forEach((f) => {
							const indexToRemove = this.modelList.map((m) => m.perfilDeAcessoId).indexOf(f)
							this.modelList.splice(indexToRemove, 1)
						})

						this.mutationShowMessage({
							messageTitle: this.$t('sucesso'),
							messageIcon: 'far fa-check-circle',
							messageType: 'success',
						})
						this.showExclusionAlert = false
					})
				}
			} else {
				this.mutationShowMessage({
					messageTitle: this.$t('wrongEmail'),
					messageIcon: 'fas fa-lock',
					messageType: 'error',
					messageText: this.$t('wrongEmaildescricao'),
				})
			}
		},

		/**
		 * Método executado quando clica no botão de salvar
		 */
		saveClick() {
			this.disableSaveButton = true
			if (this.isEdit) {
				this.update()
			} else {
				this.create()
			}
		},

		/**
		 * Configura para exibir o Model de edicao
		 */
		showEditModelForm(model) {
			model.acessos = model.roles.map((role) => role.id)
			this.rolesAuxiliar = [...model.acessos]
			this.model = Object.assign({}, model)

			this.titleForm = `${this.$t('edit')} ${this.$t('user')}`
			this.isEdit = true
			this.changeFormAndCloseAllActions()
		},

		/**
		 * Configura para exibir o Model de Cadastro
		 */
		showNewModelForm() {
			this.cleanModel()

			this.titleForm = `${this.$t('create')} ${this.$t('accessProfile')}`
			this.model.nascimento = new Date().toISOString()
			this.isEdit = false
			this.changeFormAndCloseAllActions()
		},

		/**
		 * Fecha o formulario e actions que estiverem abertas
		 */
		changeFormAndCloseAllActions() {
			this.showForm = !this.showForm
			// this.intention = {};
		},
	},
}
</script>

<style scoped src="../../../css/crud.css"></style>
<style scoped>
.correct-requirement {
	color: var(--color-success-background);
	font-weight: bold;
}
</style>
